const ITEMS = [
    "STRENGTH",
    "BUDGETING",
    "PROGRESS",
    "DISCIPLINE",
    "PERSONAL BESTS",
    "MACROS",
    "SAVINGS",
    "MEAL PLANS",
    "BALANCE",
];

export const Marquee = () => (
    <div
        data-testid="marquee"
        className="relative overflow-hidden border-y border-white/[0.06] bg-[#0d0d0e] py-5 md:py-6"
    >
        <div className="flex w-max animate-[marquee_46s_linear_infinite] items-center gap-8 pr-8 md:gap-12 md:pr-12">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span
                    key={i}
                    className="flex items-center gap-8 whitespace-nowrap md:gap-12"
                >
                    <span className="font-display text-xl font-black tracking-[0.02em] text-white/[0.9] md:text-3xl">
                        {item}
                    </span>
                    <span className="font-display text-lg font-light text-acid md:text-xl">
                        ×
                    </span>
                </span>
            ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0a0a0b] to-transparent md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0a0a0b] to-transparent md:w-40" />
    </div>
);
